export enum Location {
	InOffice,
	Remote
}

export const LocationLabels = [
	{
		key: Location.InOffice,
		label: "In Office"
	},
	{
		key: Location.Remote,
		label: "Remotely"
	}
]
